import { useQuery } from "@tanstack/react-query";
import queryKey from "../../enumerations/queryKey";
import { winBetGameWayMethods } from "../../enumerations/winBetOptions";
import { envChangeType, envType } from "../../plugins/utils";
import { getGameMethod, getGameRecord, getGameRule, getGameWay, getLatestNumber } from "./service";

export const useGetGameWay = ({ params, options }) => {
  Object.keys(params).forEach((key) => {
    if (params[key] === null || params[key] === undefined || params[key] === "") {
      delete params[key];
    }
  });
  const _arrParams = Object.keys(params).map((key) => params[key]);
  return useQuery(
    [queryKey.WIN_GAME_WAY, params, ..._arrParams],
    () =>
      getGameWay({ params: params }).then((res) => {
        const _result = res.data.data;
        return _result;
      }),
    {
      ...options,
    },
  );
};

export const useGetGameMethod = ({ params, options }) => {
  Object.keys(params).forEach((key) => {
    if (params[key] === null || params[key] === undefined || params[key] === "") {
      delete params[key];
    }
  });
  const _arrParams = Object.keys(params).map((key) => params[key]);
  return useQuery(
    [queryKey.WIN_GAME_METHOD, ..._arrParams],
    () => {
      if (
        envChangeType("REACT_APP_FIXED_WIN_OPTIONS", envType.BOOLEAN) &&
        params.game_way_type.includes("LOTWIN")
      ) {
        const _gameWayMethod = winBetGameWayMethods[envChangeType("REACT_APP_PRODUCTION_NAME_DEV")];
        if (_gameWayMethod) {
          return new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve({ data: _gameWayMethod[params.game_way_type] });
            }, 300);
          });
        }
      }
      return getGameMethod({ params: params }).then((res) => {
        const timezone = res.data.result.timezone;
        const data = res.data.data;
        return { data, timezone };
      });
    },
    {
      staleTime: 5 * (60 * 1000), //5mins
      cacheTime: 5 * (60 * 1000), //5mins
      ...options,
    },
  );
};

export const useGetGameHistory = ({ params, options }) => {
  Object.keys(params).forEach((key) => {
    if (params[key] === null || params[key] === undefined || params[key] === "") {
      delete params[key];
    }
  });
  const _arrParams = Object.keys(params).map((key) => params[key]);
  return useQuery(
    [queryKey.WIN_GAME_HISTORY, ..._arrParams],
    () =>
      getGameRecord({ params }).then((res) => {
        const _result = res.data.data;
        if (params.limit) return { ..._result, data: _result.data.slice(0, params.limit) };
        return _result;
      }),
    {
      ...options,
    },
  );
};

export const useGetGameFeeAndOdds = ({ options }) => {
  return useQuery(
    [queryKey.WIN_GAME_RULE],
    () =>
      getGameRule({}).then((res) => {
        const _result = res.data.data;
        const finalData = {};
        // console.log('_result', _result)
        if (!!_result) {
          finalData["fee"] = _result?.fee;
          _result?.odds?.map((oddsSetting) => {
            // console.log('oddsSetting', oddsSetting)
            finalData[oddsSetting.game_type] = {};
            return oddsSetting?.game_method?.map((gameContent) => {
              return gameContent.option?.map(
                (option) => (finalData[oddsSetting.game_type][option.key] = option.odds),
              );
            });
          });
        }
        // console.log("finalData", finalData);
        return finalData;
      }),
    {
      ...options,
    },
  );
};

export const useGetLatestNumber = ({ params, options }) => {
  Object.keys(params).forEach((key) => {
    if (params[key] === null || params[key] === undefined || params[key] === "") {
      delete params[key];
    }
  });
  const _arrParams = Object.keys(params).map((key) => params[key]);
  return useQuery(
    [queryKey.WIN_LATEST_NUMBER, ..._arrParams],
    () =>
      getLatestNumber({ params }).then((res) => {
        const current_time = res?.data?.result?.now;
        const _result = res.data.data.map((_data) => {
          return {
            ..._data,
            current_time: current_time,
          };
        });
        console.debug("lottery_number", _result[1].lottery_number);
        return _result;
      }),
    {
      ...options,
    },
  );
};
